import { render, staticRenderFns } from "./CourseReviewRating.vue?vue&type=template&id=451c523c&"
import script from "./CourseReviewRating.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports